import { Row, Col, Breadcrumb } from "react-bootstrap";
import { IChangeRequestDetails } from "../../../api/IChangeRequests";
import { ILicenceProfile } from "../../../api/LicenceProfile";

interface BreadcrumbProps {
  licenceProfile: ILicenceProfile;
  changeRequestDetails: IChangeRequestDetails;
}

const BreadCrumbs = ({
  licenceProfile,
  changeRequestDetails,
}: BreadcrumbProps) => (
  <Row>
    <Col xs="12">
      <Breadcrumb className="leap">
        <Breadcrumb.Item href="/">LEAP Online Home</Breadcrumb.Item>
        <Breadcrumb.Item href={`/licence-profile/${licenceProfile.profileNo}`}>
          {licenceProfile.organisation} - {licenceProfile.profileNo}
        </Breadcrumb.Item>
        <Breadcrumb.Item
          href={`/licence-profile/${licenceProfile.profileNo}/versions`}
        >
          Authorisation Versions
        </Breadcrumb.Item>
        <Breadcrumb.Item
          href={`/licence-profile/${licenceProfile.profileNo}/versions/${changeRequestDetails.licenceid}`}
        >
          {changeRequestDetails.licence_regno}
        </Breadcrumb.Item>
        <Breadcrumb.Item active>
          {changeRequestDetails.casenumber}
        </Breadcrumb.Item>
      </Breadcrumb>
    </Col>
  </Row>
);

export default BreadCrumbs;
